import React from 'react'


function matchId(url, reg, fn){
  const matches = url.match(reg)
  if (matches && matches.length > 1){
    const id = matches[1]
    return fn(id)
  }
  return undefined
}

export function videoUrl(url){
  return matchId(url, /.*youtube.*v=([a-zA-Z0-9_\-]+).*/i, id => `//www.youtube.com/embed/${id}?autoplay=0&enablejsapi=1&wmode=opaque`)
      || matchId(url, /.*youtu.be\/.*([a-zA-Z0-9_\-]+).*/i, id => `//www.youtube.com/embed/${id}?autoplay=0&enablejsapi=1&wmode=opaque`)
      || matchId(url, /.*vimeo.*\/([a-zA-Z0-9_\-]+).*/i, id => `//player.vimeo.com/video/${id}`)
      || matchId(url, /.*dailymotion.*\/video\/([a-zA-Z0-9]+)(_.*)?/i, id => `//www.dailymotion.com/embed/video/${id}`)
      || url
}

export function videoImage(url){
  // http://img.youtube.com/vi/fs8XJSXva44/hqdefault.jpg
  // https://www.youtube.com/watch?v=fs8XJSXva44
  const youtubeMatches = url.match(/.*youtube.*v=([a-zA-Z0-9_\-]+).*/i)
  if (youtubeMatches && youtubeMatches.length > 1){
    const id = youtubeMatches[1]
    return `http://img.youtube.com/vi/${id}/hqdefault.jpg`
  }
  // http://youtu.be/iBen_RIgCYE?enablejsapi=1&wmode=opaque
  const youtuMatches = url.match(/.*youtu.be\/.*([a-zA-Z0-9_\-]+).*/i)
  if (youtuMatches && youtuMatches.length > 1){
    const id = youtuMatches[1]
    return `http://img.youtube.com/vi/${id}/hqdefault.jpg`
  }
  // https://vimeo.com/183178757
  // <iframe src="//player.vimeo.com/video/VIDEO_ID" width="WIDTH" height="HEIGHT" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
  const vimeoMatches = url.match(/.*vimeo.*\/([a-zA-Z0-9_\-]+).*/i)
  if (vimeoMatches && vimeoMatches.length > 1){
    const id = vimeoMatches[1]
    return `//player.vimeo.com/video/${id}`
  }
  return url
}

const videoStyles = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%'
}

export const Video = ({url, title="Video Player", name="fitvid0", id="player_1"}) => (
  <div style={{ paddingTop: '58.3333%', position: 'relative' }}>
    {/*http://img.youtube.com/vi/fs8XJSXva44/hqdefault.jpg */}
    <iframe title={title}
            src={videoUrl(url)} 
            id={id}
            allowFullScreen="" 
            style={videoStyles}
            name={name}
            frameBorder="0"></iframe>
  </div>
)


/** WEBPACK FOOTER **
 ** ./src/components/Video.js
 **/